import '.ep{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.eq{padding-left:1.5rem;}.ssr-plugin'
import '.er{margin:1rem 0;}.ssr-plugin'
import '.es{color:var(--gray-700);}.ssr-plugin'
import '.et{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="ep eq er es et"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
